import React, { useState } from "react";
import "../styles/projects.css";
import data, { tech_stacks_logos } from "../assets/data";
import Footer from "./Footer";
import ReactGA from "react-ga4";
import { Button } from "./CustomElements";
// import { width } from "@fortawesome/free-brands-svg-icons/fa42Group";
// import TransitionEffect from './TransitionEffect';


const Projects = () => {
  const [filterBy, setFilterBy] = useState("all");
  // eslint-disable-next-line
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProjectsData, setFilteredProjectsData] = useState(data);

  const handleFilterChange = (e) => {
    const value = e.target.value;
    setFilterBy(value);
    ReactGA.event({
      category: "Button.Click",
      action: "Filter Projects",
      label: value,
    });
    if (value === "all") {
      setFilteredProjectsData(data); // Show all data
    } else {
      setFilteredProjectsData(
        data.filter((project) => project.type.includes(value))
      );
    }
  };

  // search project by tech stack
  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    filterData(filterBy, value);
  };

  const filterData = (filter, search) => {
    let filtered = data;
    if (filter !== "all") {
      filtered = filtered.filter((project) => project.type.includes(filter));
    }
    if (search) {
      filtered = filtered.filter(
        (project) =>
          project.title.toLowerCase().includes(search) ||
          project.desc.toLowerCase().includes(search) ||
          project.tech_stacks.some((stack) =>
            stack.toLowerCase().includes(search)
          )
      );
    }
    setFilteredProjectsData(filtered);
  };

  return (
    <>
      {/* <TransitionEffect /> */}
      <div className="project_page">
        <div className="filter_container">
          <div className="filter_section">
            <span>Filter by:</span>
            <select
              className="filter_dropdown"
              value={filterBy}
              onChange={handleFilterChange}
            >
              <option value="all">All Projects</option>
              <option value="frontend">Frontend</option>
              <option value="backend">Backend</option>
              <option value="fullstack">Full Stack</option>
              <option value="mobility">Mobility</option>
              <option value="automation">Automation</option>
              <option value="ai">AI</option>
              <option value="iot">IOT & Electronics</option>
              <option value="priority">My Favorite</option>
            </select>
          </div>
          <h1>My Projects</h1>
          <div className="search_section">
            <span>Search by: </span>
            <input
              className="search_input"
              type="text"
              data-cursor-focusable="true"
              name="search-project"
              placeholder="React, Python, Java etc."
              onChange={handleSearchChange}
            />
          </div>
        </div>
        <div className="project_conatiner animation">
          {filteredProjectsData.map((d, index) => {
            const hasProjectUrl = !!d?.project_url;
            const hasProjectDocumentation = !!d?.project_documentation;
            return (
              <div className="project_card" key={index}>
                <img src={d.image_url} alt="img" className="image" />
                <div className="card_details">
                  <span className="card_title">{d.title}</span>
                  <span className="card_desc">{d.desc}</span>
                </div>
                {/* tech stacks */}
                <div className="tech_stack_container">
                  {d?.tech_stacks?.map((tech, i) => (
                    <img
                      key={i}
                      className="tech_stack"
                      src={`${tech_stacks_logos[tech.toLowerCase()]}`}
                      alt="custom_img"
                    />
                  ))}
                </div>
                {/* buttons */}
                <div
                  className={`card_btn ${
                    hasProjectUrl && hasProjectDocumentation
                      ? ""
                      : "single_button"
                  }`}
                >
                  {d?.project_url ? (
                    <Button
                      onClick={() => window.open(d?.project_url, "_blank")}
                    >
                      Live Demo
                    </Button>
                  ) : (
                    <></>
                  )}
                  {d?.project_documentation ? (
                    <Button
                      onClick={() =>
                        window.open(d?.project_documentation, "_blank")
                      }
                    >
                      See Documentation
                    </Button>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            );
          })}
          <div className="project_card" style={{ justifyContent: "center" }}>
            <span>Comming Soon...</span>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Projects;
